module.exports = __webpack_public_path__ + "img/text.48a56aec.png";